import HTTP from "../Shared/Http";

export function getWeatherPrediction(values) {
  return new Promise((resolve, reject) => {
    HTTP.post("weather_predict", values)
      .then((respose) => resolve(respose.data))
      .catch((error) => reject(error));
  });
}
